import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import ExamplePhoto from "../components/ExamplePhoto";
import StyleGallery from "../components/StyleGallery";
import Quality from "../components/Quality";
import HowItWorks from "../components/HowItWorks";
import Footer from "../components/Footer";
import OrderDialog from "../components/OrderDialog";
import StylePreview from "../components/StylePreview";
import Testimonials from "../components/Testimonials";
import FAQ from "../components/FAQ";
import VideoProcess from "../components/VideoProcess";
import { STYLES } from "../mock";
import { useLocation } from "react-router-dom";
import { toast } from "sonner";

export default function Home() {
  const [orderStyle, setOrderStyle] = React.useState(null);
  const [previewId, setPreviewId] = React.useState(null);
  const location = useLocation();

  React.useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("canceled") === "1") {
      toast.info("Pago cancelado", {
        description: "Puedes volver a intentarlo cuando quieras.",
      });
      window.history.replaceState({}, document.title, "/");
    }
  }, [location]);

  const handleChooseFromPreview = (style) => {
    setPreviewId(null);
    // Slight delay so the preview close animation doesn't overlap
    setTimeout(() => setOrderStyle(style), 150);
  };

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <ExamplePhoto />
        <HowItWorks />
        <StyleGallery
          onChoose={(style) => setOrderStyle(style)}
          onPreview={(style) => setPreviewId(style.id)}
        />
        <Quality />
        <VideoProcess />
        <Testimonials />
        <FAQ />
      </main>
      <Footer />

      <StylePreview
        styles={STYLES}
        currentId={previewId}
        open={!!previewId}
        onClose={() => setPreviewId(null)}
        onChoose={handleChooseFromPreview}
      />

      <OrderDialog
        style={orderStyle}
        open={!!orderStyle}
        onClose={() => setOrderStyle(null)}
      />
    </>
  );
}
